import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const storeSelectedGuard: CanActivateFn = () => {
  const authSvc = inject(AuthService);
  const router  = inject(Router);

  if (authSvc.currentUser()?.companySlug) return true;

  return router.createUrlTree(['/owner/select-store']);
};
